module.exports = __webpack_public_path__ + "static/hogwartsrailways-e1f2d4b09bf2da0169a6228a70a10ae3.jpg";